import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, switchMap, of } from 'rxjs';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';

@Injectable({
    providedIn: 'root'
})
export class ContactMechanismPurposeDataService extends DefaultDataService<ContactMechanismPurposeTypes> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService) {
        super('ContactMechanismPurpose', http, httpUrlGenerator);
    }

    override getAll(): Observable<ContactMechanismPurposeTypes[]> {
        const url = this.urlProvider.getUrl(EndPoints.contactMechanisms_indexContactMechanismPurposeTypes, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<ContactMechanismPurposeTypes[]>res.body['contactMechanismPurposeTypes']);
                })
            );
    }
}
